import { Flex, Skeleton } from '@buffer-mono/popcorn'

import type { JSX } from 'react'

export const TagsLoadingSkeleton = (): JSX.Element => (
  <Flex direction="column" gap="sm" fullWidth>
    {[0, 1, 2, 3, 4].map((index) => (
      <Skeleton key={index} width="100%" height="64px" />
    ))}
  </Flex>
)
